import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SuitabilityModel extends Model {
  @attr('boolean') children!: boolean;
  @attr('boolean') pets!: boolean;
  @attr('number') petCapacity!: number | null;
  @attr('boolean') events!: boolean;
  @attr('boolean') smoking!: boolean;

  @belongsTo('property', { inverse: 'suitability', async: false })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    suitability: SuitabilityModel;
  }
}
